class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();

    const customMenu = this.querySelector('.mega-menu--custom');
    const detailsMenu = this.querySelector('details');

    if (customMenu) {
      // First menu item: hover behavior
      this.setupHoverBehavior();
    } else if (detailsMenu) {
      // Other menu items: click behavior using details
      this.setupDetailsDisclosure();
    }
  }

  setupHoverBehavior() {
    const content = this.querySelector('.mega-menu__content');
    if (!content) {
      return;
    }

    const desktopMql = window.matchMedia('(min-width: 990px)');
    const languageSelector = this.querySelector('.apt-language-selector');
    const headerAccount = document.querySelector('.header__account');
    const accountLink = headerAccount?.querySelector('a');

    const canMoveLanguageSelector = () => {
      return Boolean(desktopMql.matches && languageSelector && headerAccount && accountLink);
    };

    const restoreLanguageSelector = () => {
      if (!languageSelector) return;

      const originalParent = languageSelector.__aptOriginalParent;
      const originalNextSibling = languageSelector.__aptOriginalNextSibling;

      if (!originalParent) return;

      if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
        originalParent.insertBefore(languageSelector, originalNextSibling);
      } else {
        originalParent.appendChild(languageSelector);
      }
    };

    const moveLanguageSelectorToHeader = () => {
      if (!canMoveLanguageSelector()) return;

      if (!languageSelector.__aptOriginalParent) {
        languageSelector.__aptOriginalParent = languageSelector.parentElement;
        languageSelector.__aptOriginalNextSibling = languageSelector.nextElementSibling;
      }

      if (languageSelector.parentElement === headerAccount) return;

      headerAccount.insertBefore(languageSelector, accountLink);
    };

    const syncLanguageSelectorPlacement = () => {
      if (desktopMql.matches) {
        moveLanguageSelectorToHeader();
      } else {
        restoreLanguageSelector();
      }
    };

    // Ensure content starts hidden immediately
    content.style.opacity = '0';
    content.style.transform = 'translateY(-1.5rem)';
    content.style.visibility = 'hidden';

    let hoverTimeout;

    this.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      content.classList.add('mega-menu__content--visible');
    });

    this.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        content.classList.remove('mega-menu__content--visible');
      }, 100);
    });

    syncLanguageSelectorPlacement();
    desktopMql.addEventListener('change', syncLanguageSelectorPlacement);
  }

  setupDetailsDisclosure() {
    const details = this.querySelector('details');
    const header = document.querySelector('.header-wrapper');

    if (!details) return;

    // Handle focus out
    details.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          details.removeAttribute('open');
        }
      });
    });

    // Handle toggle for header positioning
    details.addEventListener('toggle', () => {
      if (!header) return;

      header.preventHide = details.open;

      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(header.getBoundingClientRect().bottom)}px`
      );
    });
  }
}

customElements.define('header-menu', HeaderMenu);
